import React, { memo, useCallback } from 'react'

import { string, bool, func, number } from 'prop-types'

function VimeoSlide({ externalId, isActiveSlide, onLoad, slideIndex }) {
  const handleLoad = useCallback(() => {
    if (onLoad) {
      onLoad(slideIndex)
    }
  }, [onLoad, slideIndex])

  if (!isActiveSlide) {
    return null
  }

  return (
    <div className="gallery-area-top-carousel__video-wrapper">
      <iframe
        title="vimeo-video"
        src={`https://player.vimeo.com/video/${externalId}?dnt=1&autoplay=1&muted=1`}
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
        className="gallery-area-top-carousel__video"
        data-video-id={externalId}
        loading="lazy"
        onLoad={handleLoad}
      />
    </div>
  )
}

VimeoSlide.propTypes = {
  externalId: string.isRequired,
  isActiveSlide: bool.isRequired,
  onLoad: func,
  slideIndex: number,
}

export default memo(VimeoSlide)
